<div class="fixed top-0 left-0 h-1 w-full overflow-hidden bg-[#FAFAFA]" *ngIf="isNavigating">
    <div
        class="animate-progress origin-left-right h-full w-full bg-[#0045E6]"
    ></div>
</div>
<router-outlet></router-outlet>
